import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function ListingCard({ listing, index = 0 }) {
  return (
    <Link
      to={`/collection/${listing.slug}`}
      data-testid={`listing-card-${listing.slug}`}
      className="group block"
    >
      <div className="img-zoom relative aspect-[4/5] bg-sand/40">
        <img
          src={listing.cover_image}
          alt={`${listing.name} — ${listing.category} à ${listing.city}`}
          loading={index < 2 ? "eager" : "lazy"}
          className="w-full h-full object-cover transition-[filter] duration-700 group-hover:brightness-[1.04]"
        />
        <span className="absolute top-4 left-4 bg-ivory/90 text-ink overline px-3 py-1.5">{listing.city}</span>
      </div>
      <div className="pt-6 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-serif text-3xl sm:text-4xl leading-[1.08] transition-colors duration-300 group-hover:text-ink/80">{listing.name}</h3>
          <p className="overline text-ink/50 mt-3">{listing.category}</p>
          <p className="text-xs tracking-wide text-ink/45 mt-4">{(listing.amenities || []).slice(0, 3).join("  •  ")}</p>
        </div>
        <span className="mt-1 w-11 h-11 shrink-0 border border-ink/20 flex items-center justify-center transition-colors duration-300 group-hover:bg-ink group-hover:text-ivory">
          <ArrowUpRight size={18} />
        </span>
      </div>
    </Link>
  );
}
